import { mutator } from 'satcheljs';
import {
    setUpNextCalendarEventInStore,
    updateLoadingInitialData,
    initializePane,
} from '../actions/internalActions';
import { updateSelectedCalendarEvent } from '../actions/publicActions';
import { getScenarioSelectors } from '../selectors/agendaStoreSelectors';
import { getAgendaStore } from '../store/agendaStore';
import { createLockedCalendarEventsStore } from 'owa-calendar-events-store';

mutator(setUpNextCalendarEventInStore, actionMessage => {
    const { upNext, scenarioId } = actionMessage;
    const { getPane } = getScenarioSelectors(scenarioId);
    getPane().nextCalendarEvent = upNext;
});

mutator(updateSelectedCalendarEvent, actionMessage => {
    const { selectedCalendarEventId, scenarioId } = actionMessage;
    const { getPane } = getScenarioSelectors(scenarioId);
    getPane().selectedCalendarEventId = selectedCalendarEventId;
});

mutator(updateLoadingInitialData, actionMessage => {
    const { isLoading, scenarioId } = actionMessage;
    const { getPane } = getScenarioSelectors(scenarioId);
    getPane().loadingInitialData = isLoading;
});

mutator(initializePane, actionMessage => {
    const { scenarioId } = actionMessage;
    if (!getAgendaStore().panes.get(scenarioId)) {
        getAgendaStore().panes.set(scenarioId, {
            nextCalendarEvent: { id: null, index: null },
            selectedCalendarEventId: null,
            loadingInitialData: true,
            eventsCacheLockId: createLockedCalendarEventsStore().getLockId(),
        });
    }
});
